import { NgModule } from '@angular/core';
import { BackendModule } from '@freelancer/datastore/core';
import { StoreModule } from '@ngrx/store';
import { supportFeedbackIsAllowedBackend } from './support-feedback-is-allowed.backend';
import { supportFeedbackIsAllowedReducer } from './support-feedback-is-allowed.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(
      'supportFeedbackIsAllowed',
      supportFeedbackIsAllowedReducer,
    ),
    BackendModule.forFeature(
      'supportFeedbackIsAllowed',
      supportFeedbackIsAllowedBackend,
    ),
  ],
})
export class DatastoreSupportFeedbackIsAllowedModule {}
